import './InviteUserModal.css';

import React, { useState } from 'react';
import { Box } from '@mui/material';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import OrganizationRoles from '../components/organization/OrganizationRoles';
import EditText from '../../b2b-common/EditText';
import { showNotification } from '../../b2b-common/Notification';
import { useContentContext } from '../../layout/Layout';
import { inviteMemberByEmail } from '../../../services/b2b-users-apiService';
import { useLoginContext } from '../../../App';

const InviteUserModal = ({ open, onCancel }) => {
    const { t } = useB2BTranslation('b2b-users');
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const [member, setMember] = useState(
        {
            email: '',
            roles: [],
            expirationTime: 720, // Default to 12 hours
        }
    );
    
    const handleSave = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!member.email) {
            showNotification(setNotification, t('Email is required'), 'warning', 3000);
            return;
        }
        if (!emailRegex.test(member.email)) {
            showNotification(setNotification, t('Invalid email format'), 'warning', 3000);
            return;
        }
        if (member.roles.length === 0) {
            showNotification(setNotification, t('A member role is required'), 'warning', 3000);
            return;
        }
        try {
            console.log('Inviting member:', member);
            const response = await inviteMemberByEmail(loginData.loggedOrganizationUuid, member.email, member.roles[0].roleName, member.expirationTime, loginData.accessToken);
            if (response) {
                showNotification(setNotification, t('Member invited successfully'), 'success', 3000);
                onCancel(); // Close the modal after saving
            }
        } catch (error) {
            console.error('Error inviting member:', error);
            showNotification(setNotification, t('Error inviting member'), 'error', 5000);
        }
    }

    const handleCancel = () => {
        onCancel(); // Close the modal
    }

    return (
        <B2BPopUpForm
            open={open}
            title={t('Invite a new member')}
            onClose={handleCancel}
            className={'invite-member-modal b2b-light-01'}
            buttons={[
                { label: t('Invite'), onClick: handleSave },
                { label: t('Cancel'), onClick: handleCancel },
            ]}
        >
            <Box display={'flex'} flexDirection={'column'} gap={3} className={'invite-member-modal-content'}>
                <EditText object={member} objectField='email' setObjectField={setMember} label={t('Email')} />
                <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} gap={3}>
                    <OrganizationRoles
                        memberRoles={member.roles}
                        multiSelect={false}
                        className={'invite-member-roles'}
                        onUpdateRoles={(roles) => {
                            setMember({ ...member, roles });
                        }}
                    />                
                    <EditText
                        object={member}
                        objectField="expirationTime"
                        setObjectField={setMember}
                        label={t('Expiration Time')}
                        options={[
                            { label: t('12 hours'), value: 720 },
                            { label: t('24 hours'), value: 1440 },
                            { label: t('48 hours'), value: 2880 },
                            { label: t('72 hours'), value: 4320 },
                        ]}
                        type="select"
                        className={'invite-member-expiration-time'}
                    />
                </Box>
            </Box>
        </B2BPopUpForm>
    )
}

export default InviteUserModal;